require("../../sass/core.sass");

import { ApolloProvider } from "react-apollo";
import client from "../helpers/apollo-client";

let browserHistory = require("react-router").browserHistory;
let Provider = require("react-redux").Provider;
import React from "react";
let Router = require("react-router").Router;
let Route = require("react-router").Route;

let Modal = require("./modal");
let FortWrapper = require("../components/fort-wrapper");

import store from "../stores/reduxStore";

class Fort extends React.Component {
    render() {
        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <div style={{ width: "100%" }}>
                        <Router history={browserHistory}>
                            <Route
                                path="/fort/members/(:creatorId)/customer/(:invoices)/"
                                component={FortWrapper}
                            />
                            <Route
                                path="/fort/members/(:creatorId)/customer/(:invoices)/(:chargeId)/edit/"
                                component={FortWrapper}
                            />
                            <Route
                                path="/fort/members/(:creatorId)/"
                                component={FortWrapper}
                            />
                            <Route
                                path="/fort/icon/(:iconId)/"
                                component={FortWrapper}
                            />
                            <Route
                                path="/fort/collections/(:collectionId)/"
                                component={FortWrapper}
                            />
                        </Router>
                        <Modal />
                    </div>
                </Provider>
            </ApolloProvider>
        );
    }
}

module.exports = Fort;
